/**
 * @file The seller counts a `salesClosedByTeam` answer serves: each team's
 * `teamSalespeople` and the whole result's `totalSalespeople`, the same on
 * every row. Consumer: the Overview's team table. The total is the server's
 * own distinct count, never a sum over teams, so a seller credited in two
 * teams counts once. An answer that has not answered, an unknown team or a
 * count that is not a number counts nothing (null), never zero.
 */
import type { Snapshot } from 'valtio';

import type { NamedQueryCell } from '#types';

import type { AnalyticsTeamSalespeople } from './analyticsOverviewTab.types';
import type { AnalyticsAnswer } from './index.types';

const countOf = (cell: NamedQueryCell | undefined): number | null =>
  typeof cell === 'number' ? cell : null;

export const analyticsTeamSalespeople = (
  answer: Snapshot<AnalyticsAnswer> | undefined,
): AnalyticsTeamSalespeople => {
  const rows = answer?.status === 'answered' ? answer.result.rows : [];
  return {
    total: countOf(rows[0]?.totalSalespeople),
    ofTeam: (teamId) =>
      countOf(rows.find((row) => row.teamId === teamId)?.teamSalespeople),
  };
};
